import React from 'react';
import { ButtonColor, ButtonVariant, Hyperlink, IconButton } from 'react-magma-dom';
import { CloseModalIcon } from '../../assets/icons/ImageEditTool';
import { StyledTermsOfUseModalDoneButton } from '../Styled/StyledButtons';
import { StyledTermsOfUseContentHeader, StyledTermsOfUseContentSubheader } from '../Styled/StyledHeader';
import { StyledTermsOfUseList, StyledTermsOfUseListItem } from '../Styled/StyledList';
import { StyledTermsOfUseContent, StyledTermsOfUseContentBlock } from '../Styled/StyledWrappers';
import { ScrollableModal } from './ScrollableModal';

interface ITermsOfUseModal {
  onClose: () => void;
}

export const TermsOfUseModal = (props: ITermsOfUseModal): JSX.Element => {
  const { onClose } = props;

  return (
    <ScrollableModal onClose={onClose}>
      <IconButton
        aria-label="Close terms of use modal window"
        color={ButtonColor.secondary}
        variant={ButtonVariant.link}
        icon={<CloseModalIcon />}
        onClick={onClose}
      />
      <StyledTermsOfUseContent data-testid="terms-of-use-content">
        <StyledTermsOfUseContentHeader>PM Writing Teacher Portal (Product)</StyledTermsOfUseContentHeader>
        <StyledTermsOfUseContentSubheader>Licence terms</StyledTermsOfUseContentSubheader>
        <StyledTermsOfUseContentBlock>
          This is a non-exclusive licence between you (the Customer) and Cengage Learning Australia Pty Limited (ABN 14
          058 280 149) (Cengage).
          <br />
          <br />
          Copyright in the Product (which includes all images, photographs, video, animations, music, and text
          incorporated in the Product, and including all of the accompanying printed materials) is owned by Cengage
          and/or its suppliers and is protected by Australian copyright laws. Cengage grants the Customer a
          non-exclusive licence to use the Product for the Permitted Use subject to the restrictions and terms set out
          in this Agreement and the Terms of Use on Cengage’s{' '}
          <Hyperlink target="_blank" to="https://pmwriting.cengagelearning.com.au">
            website
          </Hyperlink>
          .
          <br />
          <br />
          Permitted Use means non-commercial educational or instructional purposes within the purchasing institution.
        </StyledTermsOfUseContentBlock>
        <StyledTermsOfUseContentSubheader>Institution-user licence</StyledTermsOfUseContentSubheader>
        <StyledTermsOfUseContentBlock>
          Access to the Product is via an institution access code. The Customer may authorise its instructors and
          administration staff (Authorised Users) to use the access code for the Permitted Use on the condition that the
          Customer ensures that the Authorised Users comply with these terms. The Customer shall take all reasonable
          precautions necessary to safeguard against unauthorised access and use of the Product through the Customer’s
          access code including ensuring that an Authorised User ceases use of the Product after that Authorised User is
          no longer associated with the Customer’s institution.
          <br />
          <br />
          You may not:
          <br />
          <StyledTermsOfUseList>
            <StyledTermsOfUseListItem>
              Modify, adapt, translate, reverse engineer, decompile or disassemble the Product or create derivative
              works based on the Product
            </StyledTermsOfUseListItem>
            <StyledTermsOfUseListItem>
              Remove or alter any copyright or proprietary notice or label attached to the Product or create derivative
              works based on the Product
            </StyledTermsOfUseListItem>
          </StyledTermsOfUseList>
        </StyledTermsOfUseContentBlock>
        <StyledTermsOfUseContentSubheader>Termination</StyledTermsOfUseContentSubheader>
        <StyledTermsOfUseContentBlock>
          The Customer agrees that Cengage may terminate or suspend this licence and use of the Product without
          liability or refund, if in Cengage’s sole determination, the Customer and/or Authorised User has breached the
          terms. Upon termination of this Licence for any reason, the Customer must delete, destroy or return to the
          Licensor all copies of the Product and accompanying documents.
        </StyledTermsOfUseContentBlock>
        <StyledTermsOfUseContentSubheader>Warranties</StyledTermsOfUseContentSubheader>
        <StyledTermsOfUseContentBlock>
          To the fullest extent permitted by applicable law, Cengage disclaims all warranties, express and implied,
          including but not limited to, implied warranties of merchantability and fitness for a particular purpose.
          Cengage does not warrant that the Product will be uninterrupted or error-free, that defects will be corrected,
          or that the product or servers that make them available are free of viruses or other harmful components.
          <br />
          <br />
          Without limiting the foregoing, Cengage’s total liability will at all times be limited to the fees the
          Customer has paid to Cengage for the Products at issue during the prior three (3) months.
        </StyledTermsOfUseContentBlock>
        <StyledTermsOfUseContentSubheader>Indemnification</StyledTermsOfUseContentSubheader>
        <StyledTermsOfUseContentBlock>
          You agree to indemnify, defend and hold harmless Cengage, its affiliates and suppliers, and their respective
          directors, officers, employees and representatives, from any and all demands, claims, actions, damages,
          losses, liabilities, costs and expenses, including attorney’s fees and court costs, directly or indirectly
          arising out of or in connection with the Customers access or use of the Product or the Customers violation of
          any of these terms. This paragraph shall survive any expiration or termination of these terms.
        </StyledTermsOfUseContentBlock>
        <StyledTermsOfUseContentSubheader>Instructor Use</StyledTermsOfUseContentSubheader>
        <StyledTermsOfUseContentBlock>
          In Australia and New Zealand, the extent of instructor permissible copying, reproduction or display of Cengage
          Content is governed by Copyright law and your institution, or representative body, agreement with Copyright
          Agency Limited in Australia (“CAL”) or Copyright Licensing New Zealand (“CLNZ”) for which an annual fee per
          student is paid. Permission for use beyond that permitted by your agreement with CAL of CLNZ must be south
          directly from Cengage at{' '}
          <Hyperlink target="_blank" to="https://www.cengage.com.au/permissions">
            https:www.cengage.com.au/permissions
          </Hyperlink>
          .
          <br />
          <br />
          For clarity, personal use by instructors and students within the designated Cengage platform is granted with
          these Terms of Use and free of obligations under agreements with CAL and CLNZ, however, any copying,
          reproduction or display of Cengage Content outside of the designated Cengage platform (e.g. producing in-class
          handouts for students) is subject to your agreement(s) with CAL and/or CLNZ.
          <br />
          <br />
        </StyledTermsOfUseContentBlock>
        <StyledTermsOfUseModalDoneButton onClick={onClose}>Done</StyledTermsOfUseModalDoneButton>
      </StyledTermsOfUseContent>
    </ScrollableModal>
  );
};
